export enum TransferRequestStatusEnum {
  Draft = 'Draft',
  WaitingForApproval = 'WaitingForApproval',
  Completed = 'Completed',
  Scheduled = 'Scheduled',
  Cancelled = 'Cancelled',
}
